var _desc, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "POS Terminal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A solid styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer2",
    fill: "#8d8ea3",
    d: "M44 18h8v36h-8zm15 0h-3v36h3a3 3 0 0 0 3-3V21a3 3 0 0 0-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    d: "M37 2H5a3 3 0 0 0-3 3v54a3 3 0 0 0 3 3h32a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm-27 8h22v16H10zm2 44h-2a2 2 0 0 1 0-4h2a2 2 0 1 1 0 4zm0-8h-2a2 2 0 0 1 0-4h2a2 2 0 1 1 0 4zm0-8h-2a2 2 0 0 1 0-4h2a2 2 0 1 1 0 4zm10 16h-2a2 2 0 1 1 0-4h2a2 2 0 0 1 0 4zm0-8h-2a2 2 0 0 1 0-4h2a2 2 0 1 1 0 4zm0-8h-2a2 2 0 1 1 0-4h2a2 2 0 0 1 0 4zm10 16h-2a2 2 0 1 1 0-4h2a2 2 0 0 1 0 4zm0-8h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4zm0-8h-2a2 2 0 1 1 0-4h2a2 2 0 0 1 0 4z",
    fill: "#253858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank4);
export default __webpack_public_path__ + "static/media/bank4.dfdbbe26ac2aabe8e25dd5e135a06daf.svg";
export { ForwardRef as ReactComponent };